import { render, staticRenderFns } from "./sflf.vue?vue&type=template&id=72f2da44&"
import script from "./sflf.vue?vue&type=script&lang=js&"
export * from "./sflf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports